import {createStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import Reducer from './reducer';
import {composeWithDevTools} from 'redux-devtools-extension';

const rootReducer = combineReducers({
    Reducer,
});
export const store = createStore(rootReducer, composeWithDevTools(applyMiddleware(thunk)));
